import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useDetailOrder = (id: number) =>
  useQuery(
    ['detailOrder', id],
    async () => {
      if (id) {
        const res = await api.get(`/api/cms/order/detail/${id}`);
        return res.data.data;
      }
      return;
    },
    {
      retry: 0,
    }
  );
